<template>
  <div class="share-link">
    <keep-alive :exclude="exclude_type">
      <!--组件-->
      <component
        :is="share_type"
        :other-data="other_data"
        @create="createLink"
        @history="showHistory"
        @closeDialog="changeDialog"
        @reqApproval="reqApproval"
      />
    </keep-alive>
  </div>
</template>

<script>

// 引入组件
import { SHARE_TYPE, checkCanCreate, linkNum } from './index'
import mgdelivery from './components/link-history.vue'
import commonLink from './components/ordinary.vue'
import secureLink from './components/security.vue'
import smartShare from './components/smart.vue' // 这个暂时不做
import createNewLink from './components/privateCreateNewLink/createNewLink.vue'

export default {
  name: 'commonLinkDispatch',
  components: {
    commonLink,
    secureLink,
    smartShare,
    mgdelivery,
    createNewLink,
  },
  props: {
    shareType: { // 外链类型 1：普通 2：安全 3：smart
      type: String,
      default: SHARE_TYPE.createNewLink,
    },
    otherData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      exclude_type: [
        SHARE_TYPE.commonLink, SHARE_TYPE.secureLink, SHARE_TYPE.smartShare, SHARE_TYPE.mgdelivery,
      ],
      share_type: SHARE_TYPE.createNewLink, // 外链分享类型
      other_data: {}, // 分享对象数据
    }
  },
  created() {
    // 赋值传入的只读参数
    this.share_type = this.shareType
    this.other_data = this.otherData
    // 输出分享文件类型
    console.log(this.shareType, '--外链类型--')
  },
  methods: {
    /**
         * 审批弹窗
         */
    reqApproval(d) {
      this.$emit('reqApproval', d)
      // 关闭原来的弹窗
      this.changeDialog('close')
    },
    /**
         * 创建链接前的验证
         * @param key       创建文件的类型
         * @param metaData 文件对象
         * @param isNew 新创建外链还是获取外链数据
         * @param hisVersion 获取分享数据的参数
         */
    createLink(key, metaData, isNew = true, hisVersion = {}) {
      // 判断文件的数量,邮箱验证,odc
      linkNum(metaData, (response) => {
        const res = response
        if (res) {
          // 判断创建外链的权限
          checkCanCreate(key, metaData, (checkInfo) => {
            // 重置isNew
            res.isNew = isNew
            // 打印返回的数据
            if (checkInfo.flag) {
              // 初始化赋值
              this.share_type = key
              this.other_data = Object.assign(res, checkInfo.mixData,
                { meta: metaData }, hisVersion)
              // 抛出事件修改弹窗样式
              this.changeDialog('create')
            }
          })
        }
      }, (op) => {
        // 关闭弹窗
        this.changeDialog(op)
      })
    },
    /**
         * 显示当前历史列表
         */
    showHistory(key, metaData) {
      this.share_type = key
      this.other_data = metaData
      // 抛出事件修改弹窗样式
      this.changeDialog('history')
    },
    /**
         * 关闭dialog
         */
    changeDialog(operation, data = {}) {
      this.$emit('changeDialog', operation, data)
    },
  },
}
</script>

<style lang="less" scoped>
  #en{
    .share-link{
      width: 520px;
    }
  }
</style>
